export enum BuyInName {
  MICRO = 'Micro',
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  FREEROLL = 'Freeroll',
}

export interface BuyInOption {
  buyInName: BuyInName;
  range: {
    min: number;
    max: number | undefined;
  };
}

export interface BuyInOptionFilter {
  min: number;
  max: number | undefined;
}
